export const isFunction = (val) => typeof val === 'function';
//# sourceMappingURL=function.js.map